import { render, staticRenderFns } from "./LinkButtons.vue?vue&type=template&id=251ca3fa&scoped=true"
import script from "./LinkButtons.vue?vue&type=script&lang=js"
export * from "./LinkButtons.vue?vue&type=script&lang=js"
import style0 from "./LinkButtons.vue?vue&type=style&index=0&id=251ca3fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251ca3fa",
  null
  
)

export default component.exports